export default __webpack_public_path__ + "static/DSC_0151-380462d71c0f082e7f11faef64472018.jpg";